// UTF-8
// DOMContentLoadedを待ってから初期化
document.addEventListener('DOMContentLoaded', function() {

  try {
    const mvSwiper = new Swiper('.mv_inner .swiper_slide', {
      modules: [EffectCarousel],
      effect: 'carousel',
      carouselEffect: {
        opacityStep: 0.33,
        scaleStep: 0.2,
        sideSlides: 2,
      },
      grabCursor: true,
      loop: true,
      loopAdditionalSlides: 3,
      slidesPerView: 1.1,
      breakpoints: {
        768: {
          slidesPerView: 1.35,
        },
      },
      navigation: {
        nextEl: '.mv .swiper-button-next',
        prevEl: '.mv .swiper-button-prev',
      },
      pagination: {
        el: '.mv .swiper-pagination',
        clickable: true,
      },
    
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 600,
    });
  } catch(error) {
    throw error;
  }
});

// About Image Zoom Animation with GSAP
document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  const aboutImgZoom = document.querySelector('.about_img_zoom');

  if (aboutImgZoom) {
    gsap.to(aboutImgZoom, {
      scale: 1.3,
      ease: 'none',
      scrollTrigger: {
        trigger: '.about',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      }
    });
  }

  // New Arrival Swiper
  const newArrivalSwiper = new Swiper('.new_arrival_swiper', {
    slidesPerView: 1.5,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
      nextEl: '.new_arrival-button-next',
      prevEl: '.new_arrival-button-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    speed: 600,
    breakpoints: {
      768: {
        slidesPerView: 3.5,
        spaceBetween: 32,
      }
    }
  });

  // Ranking Swiper
  const rankingSwiper = new Swiper('.ranking_swiper', {
      slidesPerView: 1.5,
      spaceBetween: 20,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 600,
      breakpoints: {
        768: {
          slidesPerView: 5,
          spaceBetween: 10,
        }
      }
    });

  // Instagram Swiper (independent from other swipers)
  const instagramSwiperEl = document.querySelector('.instagram_swiper');
  if (instagramSwiperEl) {
    new Swiper('.instagram_swiper', {
      slidesPerView: 'auto',
      loop: true,
      loopAdditionalSlides: 10,
      allowTouchMove: false,
      speed: 6000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }
});